"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShadePicker = exports.shadePicker = exports.defaulShadePickerContext = exports.ShadePickerProvider = void 0;
var _openShadePicker = require("@ori-events/open-shade-picker");
var _react = require("react");
const defaulShadePickerContext = exports.defaulShadePickerContext = {
  mode: _openShadePicker.ShadePickerMode.QuickBuy,
  goToUrl: '',
  productCode: ''
};
const shadePicker = exports.shadePicker = /*#__PURE__*/(0, _react.createContext)(defaulShadePickerContext);
const ShadePickerProvider = exports.ShadePickerProvider = shadePicker.Provider;
const useShadePicker = () => (0, _react.useContext)(shadePicker);
exports.useShadePicker = useShadePicker;
//# sourceMappingURL=shadePickerContext.js.map